angular.module('llax')
    .controller('EditUserAccountController',
        function($rootScope, $scope, $modalInstance, $q, growl, data, RolesService, UsersResource, UsersGroupService) {
            $scope.filters = data.filters;
            $scope.userAccount = angular.copy(data.userAccount);
            $scope.roleMetadataByName = data.roleMetadataByName || {};

            $scope.selectedGroups = [];
            $scope.effectiveRoles = [];
            $scope.groups = [];

            function currentOrganization() {
                return data.organization || $rootScope.organization || {};
            }

            function showSystemRoles() {
                var value = _.get($rootScope, 'systemSettings.UI_SHOW_SYSTEM_ROLES');
                return value === true || value === 'true';
            }

            function systemRoleNamesForCurrentOrganization() {
                if (!showSystemRoles()) {
                    return [];
                }

                var organization = currentOrganization();
                return _.compact(_.map($scope.roleMetadataByName, function(role) {
                    if (role.system !== true) {
                        return null;
                    }
                    if (role.name === '__system__shared_items') {
                        return organization.itemNamespaceReadonly ? role.name : null;
                    }
                    if (role.name === '__system__buyer') {
                        return organization.organizationRole === 'INVITED_BUYER' ? role.name : null;
                    }
                    if (role.name === '__system__supplier') {
                        return organization.organizationRole === 'INVITED_SUPPLIER' ? role.name : null;
                    }
                    return null;
                }));
            }

            function getRoleDefinitions() {
                RolesService.getAllRoleDefinitions().then(function(roles) {
                    $scope.roleMetadataByName = _.keyBy(roles, 'name');
                    $scope.updateEffectiveRoles($scope.selectedGroups);
                });
            }

            $scope.updateEffectiveRoles = function(groups) {
                $scope.selectedGroups = groups;
                if (_.isArray(groups)) {
                    var allroles = _.concat(_.flattenDeep(_.map(groups,'roles')),
                                            _.get($scope,'userAccount.roles') || [],
                                            systemRoleNamesForCurrentOrganization());
                    $scope.effectiveRoles = _.union(allroles);
                }
            };

            $scope.updateUser = function() {
                var request_payload = {};
                request_payload.restrictionQuery = $scope.userAccount.restrictionQuery;
                request_payload.restrictionFilter = $scope.userAccount.restrictionFilter;
                request_payload.groupIds = _.map($scope.selectedGroups,'id');
                request_payload.roles = $scope.userAccount.roles;
                UsersResource.updateUser({
                    accountId: $scope.userAccount.id,
                    payload: request_payload
                }, function(response) {
                    UsersGroupService.reloadUsersAndGroups();
                    $modalInstance.close(true);
                    growl.success("USER_MANAGEMENT.USER_UPDATE_SUCCESS");
                });
            };

            function roleName(role) {
                return _.get(role, 'id') || _.get(role, 'name') || role;
            }

            function roleOption(role) {
                if (_.isString(role)) {
                    return {
                        id: role,
                        text: role
                    };
                }
                return role;
            }

            function isAssignableRole(role) {
                role = roleName(role);
                return _.isString(role) && role.indexOf('__system__') !== 0;
            }

            function setAssignableRoles(roles) {
                $scope.roles = _.map(_.filter(roles, isAssignableRole), roleOption);
            }

            function getRoles() {
                RolesService.getAllRoles().then(function(roles) {
                    setAssignableRoles(roles);
                });
            }

            function prepareGroups() {
                if (_.isArray(data.allGroups)) {
                    $scope.groups = data.allGroups;
                    if (data.userAccount && _.isArray(data.userAccount.groupIds)) {
                        $scope.selectedGroups = _.filter(data.allGroups, function(group) {
                            return data.userAccount.groupIds.indexOf(group.id) > -1;
                        });
                    }
                    $scope.updateEffectiveRoles($scope.selectedGroups);
                }
            }

            $scope.close = function(userAccount) {
                $modalInstance.close();
            };

            (function init() {
                if (_.isArray(data.allRoles)) {
                    setAssignableRoles(data.allRoles);
                } else {
                    getRoles();
                }
                if (_.isEmpty($scope.roleMetadataByName)) {
                    getRoleDefinitions();
                }
                prepareGroups();
            })();
        });
